import * as yup from 'yup'

import { CancelPolicyFormValidationSchema } from '../PoliciesForm/validations'

// The upper bound asset accepts (30 days); kept in step with its validation.
export const MAX_CUTOFF_HOURS = 720

// The cancel-policy rules for the basic details, but an add-on policy may have no rules at all: a removal
// is then free until the cut-off.
export const AddOnPolicyFormValidationSchema =
  CancelPolicyFormValidationSchema.shape({
    cutoffHours: yup
      .number()
      .typeError('This field is required')
      .integer('Enter a whole number of hours')
      .min(0, 'Enter a whole number of hours')
      .max(MAX_CUTOFF_HOURS, 'At most 720 hours (30 days)')
      .required('This field is required'),
    table: yup.array()
  })
